import { render, staticRenderFns } from "./VotingPage.vue?vue&type=template&id=7f940d16&scoped=true&"
import script from "./VotingPage.vue?vue&type=script&lang=js&"
export * from "./VotingPage.vue?vue&type=script&lang=js&"
import style0 from "./VotingPage.vue?vue&type=style&index=0&id=7f940d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f940d16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
